import { Divider, Group, GroupProps, Text } from "@mantine/core";

export function PageTitle(props: { text: string } & GroupProps) {
    return <Group gap={10} align="center" {...props}>
        <Divider size="8px" h={30} color="var(--mantine-primary-color-filled)" orientation="vertical" />
        <Text fw={500} size="20px">
            {props.text}
        </Text>
    </Group>
}